import React, { Component } from 'react';
import { connect } from 'react-redux';
import { busyState } from '../store';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import { Box, CircularProgress } from '@mui/material';
import { circularProgressClasses } from '@mui/material/CircularProgress';
export class BusyContainerComponent extends Component {
  render() {
    const { 
      actions = [],
      busy, 
      busyState = {},
      children,
      className = '',
      isRequired, 
      isBusy = actions.any( action => busyState[action] || isRequired && busyState[action] === undefined ) || busy,
      position,
      top,
      left,
      height,
      size
    } = this.props;

    let xsTop = "368px"
    return <div disabled={ isBusy } className={ classNames( 'busy-container', className, { 'is-busy': isBusy } ) }>
      { children }
      { isBusy && <div className="busy-indicator">
        {this.props.className==="supercode-search"?
        <div className="spinner">
          <div className="rect1" />
          <div className="rect2" />
          <div className="rect3" />
          <div className="rect4" />
        </div>:
          <Box className={"loader"} sx={{ position:position?position:"absolute", top:{md:top?top:"62px", xs:top?top:"calc(50vh - 112px)"}, left:left?left:"calc(50% - 32px)", height:height }}>
            <CircularProgress
              variant="determinate"
              className='primary-loader'
              sx={{
                color: (theme) =>
                  // theme.palette.grey[theme.palette.mode === 'light' ? '1000' : 'white'],
                  (theme.palette.mode === 'light' ? 'white':'white'),
              }}
              size={size?size:40}
              thickness={4}
              value={100}
            />
            <CircularProgress
              variant="indeterminate"
              className='secondary-loader'
              disableShrink
              sx={{
                color: (theme) => (theme.palette.mode === 'light' ? '#FF000F':'#FF000F'),
                animationDuration: '1000ms',
                position: 'absolute',
                left: 0,
                [`& .${circularProgressClasses.circle}`]: {
                  strokeLinecap: 'round',
                strokeDasharray: "25px 200px"
                },
              }}
              size={size?size:40}
              thickness={4}
              value={10}
            />
          </Box>}
      </div> }
    </div>;
  }
}

BusyContainerComponent.propTypes = {
  actions: PropTypes.arrayOf( PropTypes.string ),
  busyState: PropTypes.shape( {} ),
  children: PropTypes.node,
  className: PropTypes.string,
  isRequired: PropTypes.bool,
  isBusy: PropTypes.bool
};

export const BusyContainer = connect( busyState )( BusyContainerComponent );